// extracted by mini-css-extract-plugin
export default {"root":"classes_root__qy+yc","card-menu":"classes_card-menu__PW2k2"};